import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationType } from '@app/shared/interfaces/lib/notification.interface';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { Observable, of } from 'rxjs';
import { catchError, ignoreElements, shareReplay } from 'rxjs/operators';
import {
  ReservationAgreementService,
  ReservationAgreementTemplate,
} from '../../../services/reservation-agreements.service';

@Component({
  standalone: false,
  selector: 'sbnb-reservation-agreement-templates',
  templateUrl: './reservation-agreement-templates.component.html',
  styleUrls: ['./reservation-agreement-templates.component.scss'],
})
export class ReservationAgreementTemplatesComponent {
  agreements$: Observable<ReservationAgreementTemplate[]> = this.service
    .fetchReservationAgreementTemplates()
    .pipe(shareReplay(1));
  agreementsError$: Observable<boolean> = this.agreements$.pipe(
    ignoreElements(),
    catchError(() => of(true))
  );

  toast = inject(ToastNotificationsService);

  constructor(
    private service: ReservationAgreementService,
    private router: Router
  ) {}

  createNewReservationAgreement() {
    this.router.navigate(['/gx/rental-agreements/new']);
  }

  activateOrDeactivateAgreement(agreement, $event) {
    agreement.is_active = $event.checked;

    this.service.updateReservationAgreement(agreement).subscribe((res: any) => {
      if (res.success) {
        return;
      }
      if (res.error) {
        agreement.is_active = !agreement.is_active;
        this.toast.open(
          `Oops! We ran into an error updating this Reservation Agreement`,
          'Dismiss',
          NotificationType.Error
        );
      }
    });
  }
}
